import React from 'react';
import { Helmet } from 'react-helmet';

const HelmetTitle = (props) => {
  const { title = '', cb } = props;

  return (
    <Helmet onChangeClientState={cb}>
      <title key="title">{title}</title>
    </Helmet>
  );
};

export default HelmetTitle;
